import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getParametrage() {
    const response = await axios.get("/api/parametrage");
    return response.data;
  },
  async setParametrage(parametrage) {
    const response = await axios.put("/api/parametrage", parametrage);
    return response.data;
  },
};
